module.exports = __webpack_public_path__ + "static/media/Apple iPhone 6s Plus Silver.7108fbaf.png";